<form *ngIf="pwdResetCommonConfig" #pwdresetForm="ngForm" class="form_align" name="pwdresetform">


  <div class="pwdresetfont header-text margin-form flex-center-align">
    {{ pwdResetCommonConfig.pwdResetHeader }}
  </div>

  <div class="pwdresetfont inst-text margin-form">
    {{ pwdResetCommonConfig.instructionMessage }}
  </div>


  <div *ngFor="let config of pwdResetFieldsConfig" class="margin-form">


    <div *ngIf="config.fieldName != 'Date_of_Birth' && !config.fieldName.includes('Password') && config.fieldName != 'Captcha' ">
      <label class="pwdresetfont label-text">{{config.displayName}}
        <span *ngIf="config.required === true" class="span_align">*</span>
      </label>
      <div class="form-group">
        <input ngModel name="{{ config.fieldName }}" #textField="ngModel" type="text" id="{{ config.fieldName }}"
          class="form-control input-hw" placeholder="{{config.displayName}}"
          pattern="{{ config.validationPattern=='other' ? config.otherPattern : config.validationPattern }}"
          required="{{ config.required }}" (change)="isDateNotRequired(pwdresetForm)"/>
        <div class="validation_style" *ngIf="textField.touched && !textField.valid">
          {{ config.validationMessage }}
        </div>
      </div>
    </div>

    <div *ngIf="config.fieldName === 'New_Password'">
      <label class="pwdresetfont label-text">{{config.displayName}}
        <span *ngIf="config.required === true" class="span_align">*</span>
      </label>
      <div class="form-group">
        <input ngModel name="{{ config.fieldName }}" #textField="ngModel" type="password" id="{{ config.fieldName }}"
          class="form-control input-hw" placeholder="{{config.displayName}}"
          pattern="{{ config.validationPattern=='other' ? config.otherPattern : config.validationPattern }}"
          required="{{ config.required }}" (change)="isDateNotRequired(pwdresetForm)"/>
        <div class="validation_style" *ngIf="textField.touched && !textField.valid">
          {{ config.validationMessage }}
        </div>
      </div>
    </div>

    <div *ngIf="config.fieldName === 'Confirm_New_Password'">
      <label class="pwdresetfont label-text">{{config.displayName}}
        <span *ngIf="config.required === true" class="span_align">*</span>
      </label>
      <div class="form-group">
        <input ngModel name="{{ config.fieldName }}" #textField="ngModel" type="password" ngValidateEqual="New_Password"
          id="{{ config.fieldName }}" class="form-control input-hw" placeholder="{{config.displayName}}"
          pattern="{{ config.validationPattern=='other' ? config.otherPattern : config.validationPattern }}"
          required="{{ config.required }}" />
        <div class="validation_style" *ngIf="textField.touched && !textField.valid">
          {{ config.validationMessage }}
        </div>
      </div>
    </div>

    <div *ngIf="config.fieldName === 'Date_of_Birth'">
      <label class="pwdresetfont label-text">{{config.displayName}}
        <span *ngIf="config.required === true" class="span_align">*</span>
      </label>
      <div class="form-group">
        <div class="input-group">
          <input id="{{ config.fieldName }}" class="form-control" name="{{ config.fieldName }}" type="text"
            ngbDatepicker #datepicker="ngbDatepicker"
            pattern="{{ config.validationPattern=='other' ? config.otherPattern : config.validationPattern }}"
            placeholder="MM/DD/YYYY" [maxDate]="maxDate" [minDate]="minDate" ngModel #Date_of_Birth="ngModel"
            required="{{ config.required }}" />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary fa fa-calendar" (click)="datepicker.toggle()" type="button">
            </button>
          </div>
          <div class="validation_style" *ngIf="datepicker.touched && !datepicker.valid">
            {{ config.validationMessage }}
          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="flex-center-align margin-form">
    <button *ngIf = "isCaptcha" ngHcaptchaInvisibleButton class="btn btn-primary btn" id="submit_btn"
      [disabled]="formSubmitted || pwdresetForm.form.invalid || isOnCaptcha" (verify)="onVerify($event,pwdresetForm)"
      (click)="captchaView()">
      Submit
    </button>
    <button *ngIf = "!isCaptcha"  class="btn btn-primary btn" id="submit_btn" [disabled]="formSubmitted || pwdresetForm.form.invalid" (click)="submitNocaptcha(pwdresetForm)">
      Submit
    </button>
  </div>
</form>